import {Component, Input} from '@angular/core';

import { MENU_ITEMS } from './pages-menu';
import {NbMenuItem, NbMenuService} from '@nebular/theme';
import { SidebarService } from '../services/sidebar.service';
import { NbAccessChecker } from '@nebular/security';

@Component({
  selector: 'ngx-pages',
  styleUrls: ['pages.component.scss'],
  template: `
    <ngx-one-column-layout>
      <nb-menu [items]="menu"></nb-menu>
      <router-outlet></router-outlet>
    </ngx-one-column-layout>
  `,
})
export class PagesComponent {
  menu: NbMenuItem[] = [];

  constructor(
    private menuService: NbMenuService,
    private sidebarService: SidebarService,
    public accessChecker: NbAccessChecker,
  ) {
    this.setMenu();

    menuService.onItemClick().subscribe((data) => {
      this.sidebarService.setActiveComponent(data.item.title);
    });
  }

  async setMenu() {
    for (const item of MENU_ITEMS) {
      const allowed = await this.getPermission(item.data);
      if (allowed) this.menu.push(item);
    }
  }

  getPermission(permission) {
    return new Promise((resolve) => {
      this.accessChecker.isGranted('view', permission).subscribe(data => resolve(data));
    });
  }
}
